import React from 'react';
import { Card } from 'react-bootstrap';

const ThisPeriodNewUsersCard = ({ loading, count }) => {
  return (
    <Card className="mb-2">
      <Card.Body>
        {/* 「今月」に限らず、セレクトされた期間に対応できるよう「選択期間」としています */}
        <Card.Title className="fs-6">新規ユーザ数（選択期間）</Card.Title>
        <div className="fs-2 fw-bold">
          {loading ? '...' : count}
        </div>
        <div className="small text-muted">
          {/* User.createdAt ベースの件数 */}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ThisPeriodNewUsersCard;
